import * as types from "../constants/ActionTypes";

const initialState = {
  selectedDealer: null,
  changeDealerModal: null,
  services: null,
  availabilities: null,
  appointment: null,
};

export function fetchPreJourneyInfo(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_PRE_JOURNEY_INFORMATION_SUCCESS:
      return {
        ...state,
        preJourneyInfo: action.preJourneyInfo,
        preJourneyInfoDeleted: false,
      };
    default:
      return state
  }
}

export function fetchCustomerAvailabilities(state = initialState, action) {
  switch (action.type) {
    case 'FETCH.CUSTOMER_AVAILABILITIES.SUCCESS':
      return {
        ...state,
        availabilities: action.availabilities,
      };
    case 'FETCH.TIRES_CHECK_AVAILABILITIES.SUCCESS':
      return {
        ...state,
        tiresAvailabilities: action.tiresAvailabilities,
      };
    default:
      return state
  }
}

export function fetchDealerTiresBrand(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_CUSTOMER_DEALER_TIRE_BRAND_SUCCESS:
      return {
        ...state,
        ...action.response,
      };
    default:
      return state
  }
}

export function saveCustomerAppointment(state = initialState, action) {
  switch (action.type) {
    case 'SAVE.CUSTOMER_APPOINTMENT.SUCCESS':
      return {
        ...state,
        appointment: action.appointment,
      };
    case 'FETCH.CUSTOMER_APPOINTMENT.SUCCESS':
      return {
        ...state,
        appointmentData: action.appointmentData,
      };
    default:
      return state
  }
}

export function fetchUserData(state = initialState, action) {
  switch (action.type) {
    case 'FETCH.CUSTOMER_HOME_DATA.SUCCESS':
      return {
        ...state,
        ...action.response,
      };
    default:
      return state
  }
}



